import { createRoot } from 'react-dom/client';
import LoginPageContentsComponent from './LoginPageContentsComponent';

class StandaloneComponent extends HTMLElement {
	connectedCallback() {
		const mountPoint = document.createElement('div');
		mountPoint.style.width = '100%';
		mountPoint.style.height = '100%';
		mountPoint.style.position = 'relative';
		this.appendChild(mountPoint);
		const root = createRoot(mountPoint);

		const navigationNodeName = this.getAttribute('navigationNodeName');
		if (navigationNodeName) {
			root.render(<LoginPageContentsComponent navigationNodeName={navigationNodeName} />);
		}
	}
}
export default StandaloneComponent;
